<template>
  <div class="bg">
    <div class="login_from">
      <div class="login_title">
        终身学习，上进创新；团队协作，互利共荣！ 
      </div>
      <div class="login_from_box">
        <div class="login_box_title">登录你的专升本账户</div>
        <div class="from_center" :class="isShowPassWorld ? '' : 'eye_open'">
          <el-form :inline="true" ref="userFormRef" :rules="rules" :model="userInfo">
            <el-form-item prop="userName" :class="isShowUserTip ? 'red_bg' : ''">
              <el-input
                :input-style="{
                  fontSize: 'inherit',
                  fontFamily: 'AlibabaPuHuiTi_2_65_Medium',
                }"
                v-model="userInfo.userName"
                :suffix-icon="Calendar"
                clearable
                placeholder="请输入账号"
                autocomplete="off"
                @keyup.enter.native="keyDown($event)"
                :disabled="telDisable"
                @blur="handleBlur"
              >
                <template #prefix>
                  <div class="icon icon_user"></div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item
              prop="passWord"
              class="pass_word"
              :class="isShowPassWorldTip ? 'red_bg' : ''"
            >
              <el-input
                :input-style="{
                  fontSize: 'inherit',
                  fontFamily: 'AlibabaPuHuiTi_2_65_Medium',
                }"
                v-model="userInfo.passWord"
                class="pass_word"
                :class="!isShowPassWorld? 'password_input': ''"
                type="text"
                autocomplete="off"
                minlength="6"
                validate-event
                placeholder="请输入密码"
                @keyup.enter.native="keyDown($event)"
              >
                <template #prefix>
                  <div class="icon icon_lock"></div>
                </template>
                <template #suffix>
                  <div
                    class="icon2"
                    :class="isShowPassWorld ? 'icon_eye_close' : 'icon_eye_open'"
                    @click="isShowPassWorld = !isShowPassWorld"
                  ></div>
                </template>
              </el-input>
              <!-- <p class="err_p" v-if="passwordRules">
            *密码必须数字与字母结合 长度必须大于或等于8位
          </p> -->
            </el-form-item>
            <el-form-item prop="loginVerificationCode" class="input_code" v-if="isShowCode">
              <el-input
                :input-style="{
                  fontSize: 'inherit',
                  fontFamily: 'AlibabaPuHuiTi_2_65_Medium',
                }"
                v-model="userInfo.loginVerificationCode"
                placeholder="请输入手机号验证码"
                @keyup.enter.native="keyDown($event)"

              >
                <template #prefix>
                  <el-icon><ChatRound /></el-icon>
                </template>
                <template #suffix>
                  <el-button
                    v-if="!loginSendSuccess"
                    slot="suffix"
                    :disabled="loginCodeDisabled"
                    class="validation pointer"
                    style="color: #409eff; font-weight: 600; border: none"
                    @click="clickLoginValidation"
                    >获取验证码</el-button
                  >
                  <el-button
                    disabled
                    v-if="loginSendSuccess"
                    slot="suffix"
                    class="validation pointer"
                    style="border: none"
                    >{{ loginCount }}s</el-button
                  >
                </template>
              </el-input>
              <el-popover
                ref="popoverRef"
                :virtual-ref="buttonRef"
                trigger="hover"
                title="验证码说明"
                class="item_popover"
                :width="350"
              >
                <div>
                  点击获取验证码后：系统会自动向当前登陆帐号关联的手机号推送短信消息，请注意查收！<br />如需调整或查看当前登陆帐号关联的手机号，请联系直属上级在慧航升本后台[管理员设置]中操作
                </div>
                <template #reference>
                  <el-button type="primary" plain>
                    <div class="item_btn">
                      <el-icon><WarningFilled /></el-icon> <span class="tips">说明</span>
                    </div>
                  </el-button>
                </template>
              </el-popover>
            </el-form-item>
          </el-form>

          <el-button
            class="submit_btn"
            type="primary"
            :disabled="isSubmitDisabled"
            @click="submitClick()"
            >{{ isSubmitDisabled ? "登录中..." : "登录" }}</el-button
          >
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { logIn, saveloginInfo, loginRoleInformation, GetAdminSmsCode,IsReLoginFromUserName } from "network/login";
import { toRefs, reactive, ref, unref, onMounted, computed } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from "vuex";

export default {
  name: "Login",
  components: {},
  props: {},
  setup(props, { emit }) {
    var validatorPassWord = (rule, value, callback) => {
      if (!value) {
        callback(new Error("*密码必须数字与字母结合 长度必须大于或等于8位"));
        data.isShowPassWorldTip = true;
      } else if (/^(?=.*\d)(?=.*[a-zA-Z])^[\da-zA-Z!#@?.$%^&*/]{8,16}$/g.test(value)) {
        callback();
        data.isShowPassWorldTip = false;
      } else {
        callback(new Error("*密码必须数字与字母结合 长度必须大于或等于8位"));
        data.isShowPassWorldTip = true;
      }
    };
    const validateTel = (rule, value, callback) => {
      // if (/^[1][3,4,5,6,7,8,9][0-9]{9}$/g.test(value)) 
      if(value)
      {
        callback();
        data.isShowUserTip = false;
      } else {
        callback(new Error("请输入用户名！"));
        data.isShowUserTip = true;
      }
    };
    const userFormRef = ref();
    const store = useStore();
    const data = reactive({
      userInfo: {
        userName: "", //用户名
        passWord: "", //密码
        loginVerificationCode: "", //登录验证码
      },
      isShowPassWorldTip: false,
      isShowUserTip: false,
      isClickLogin: false,
      passwordRules: false,
      isSubmitDisabled: false,
      isShowPassWorld: false,
      loginCode: true, //登录验证码
      loginSendSuccess: false, //登录验证码发送成功
      loginCodeDisabled: false, //登录验证码按钮隐藏
      isClickCode:false,
      loginCount: 60, //登录倒计时
      rules: {
        userName: [
          {
            required: true,
            validator: validateTel,
            trigger: ["blur", "change"],
          },
        ],
        passWord: [
          {
            required: true,
            validator: validatorPassWord,
            trigger: ["blur", "change"],
          },
        ],
        loginVerificationCode: [
          {
            required: true,
            message: "请输入手机号验证码",
            trigger: ["blur", "change"],
          },
        ],
      },
      telDisable: false,
      isShowCode:false,
      isCheck:false,
    });
    //挂载后调用函数获取项目数据
    onMounted(() => {});
    // 点击回车键登录
    const keyDown = (e) => {
      if (data.isSubmitDisabled) return;
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode == 13) {
        submitClick(); // 定义的登录方法
      }
    }; 
    // 用户名请求时是否登录过
    const handleBlur = async () =>{
      if(data.userInfo.userName=="") return
      data.isCheck = true
      let res = await IsReLoginFromUserName(data.userInfo.userName)
      console.log(res,"res")
      if(res.data.code == 1 ){
        data.isShowCode = false
      }else if(res.data.code == 2 ){
        data.isShowCode = false
        ElMessageBox.alert(res.data.message);
      }
      else {
        data.isShowCode = true
        // ElMessageBox.alert(res.data.message);
      }
    };
    // 登录验证码
    const clickLoginValidation = async () => {
      if (!data.userInfo.userName) {
        ElMessageBox.alert("请先输入账号");
        return;
      } else {
        await ElMessageBox.confirm(
          `系统将向当前登陆帐号[${data.userInfo.userName}]关联的手机号发送短信验证码,请确定帐号是否有误,发送短信验证码后将不能修改当前登陆的帐号!!`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(async () => {
            data.isClickCode = true
            data.loginCode = true;
            data.loginCodeDisabled = true;
            let loginCodeRes = await GetAdminSmsCode(data.userInfo.userName);
            if (loginCodeRes.data.code == 1) {
              ElMessageBox.alert(loginCodeRes.data.message);
              data.telDisable = true;
              data.loginSendSuccess = true;
              const TIME_COUNT = 60;
              if (!data.timerLogin) {
                data.loginCount = TIME_COUNT;
                data.loginSendSuccess = true;
                data.timerLogin = setInterval(() => {
                  if (data.loginCount > 0 && data.loginCount <= TIME_COUNT) {
                    data.loginCount--;
                  } else {
                    data.loginSendSuccess = false;
                    clearInterval(data.timerLogin);
                    data.timerLogin = null;
                  }
                }, 1000);
              }
            } else {
              data.telDisable = false;
              ElMessageBox.alert(loginCodeRes.data.message);
            }
            data.loginCodeDisabled = false;
          })
          .catch(() => {
            ElMessage({ message: "已取消", type: "info" });
          });
      }
    };
    // 提交登录
    const submitClick = async () => {
      if(data.isShowCode && !data.isClickCode){
        ElMessage({ message: "请获取验证码！", type: "warning" });
        return
      }
      if(!data.isCheck){
        handleBlur()
        return
      }
      if (data.isSubmitDisabled) return;
      const form = unref(userFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.passwordRules = false;
          data.isClickLogin = true;
          data.isSubmitDisabled = true;
          logIn(
            data.userInfo.userName,
            data.userInfo.passWord,
            data.userInfo.loginVerificationCode
          ).then((res) => {
            if (res.status === 200&&res.data.code==1) {
             
              const data = res.data.result;
              let expiresTime = data.expires_in + new Date() / 1000;
              const token = {
                AccessToken: data.access_token,
                AccessExpiresIn: expiresTime,
                RefreshToken: data.refresh_token,
              };
              store.commit("saveTokenStorage", token);
              getInfo(token);
              // const userInfo = result.Result;
            }else{
              data.isSubmitDisabled = false;
              ElMessageBox.alert(res.data.message, {
                  confirmButtonText: "确定",
                  callback: (action) => {},
                });
            }
            data.telDisable = false;
            if (res.status === 400) {
              data.isSubmitDisabled = false;
              if (res.data.error) {
                ElMessageBox.alert(res.data.error, {
                  confirmButtonText: "确定",
                  callback: (action) => {},
                });
              } else {
                ElMessageBox.alert("无法登录，请联系技术", {
                  confirmButtonText: "确定",
                  callback: (action) => {},
                });
              }
              data.isClickLogin = false;
            }
          });
        }
      } catch (error) {
        return;
      }
    };
    const getInfo = (token) => {
      let AdminCache;
      loginRoleInformation().then((result1) => {
        if (result1.code != 0) {
          // 登录成功提示
          ElMessage({ message: "登录成功！", type: "success" });
          AdminCache = result1.result;
          sessionStorage.setItem("AdminCache", JSON.stringify(AdminCache)); //存储AdminCache
          let isDelect = false;
          if (
            result1.result.roleId == result1.result.adminRoleId ||
            result1.result.roleId == result1.result.engineerRoleId
          ) {
            isDelect = true;
          } else {
            isDelect = false;
          }
          sessionStorage.setItem("isDelect", JSON.stringify(isDelect));
          saveloginInfo(token, AdminCache, isDelect);
          data.isSubmitDisabled = false;
        } else {
          AdminCache = false;
          ElMessageBox.alert(result1.message, {
            confirmButtonText: "确定",
            callback: (action) => {},
          });
          // ElMessage.error({ message: "登录失败！", type: "success" });
          data.isClickLogin = false;
          data.isSubmitDisabled = false;
        }
      });
    };

    return {
      userFormRef,
      keyDown,
      submitClick,
      getInfo,
      ...toRefs(data),
      clickLoginValidation,
      handleBlur
    };
  },
};
</script>

<style scoped>
.bg {
  position: relative;
  width: 100%;
  min-width: 1560px;
  height: 100%;
  background: url("../assets/images/login-bg-5.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.icon {
  width: 16px;
  height: 16px;
}
.icon2 {
  width: 14px;
  height: 14px;
}
.icon_lock {
  background: url("../assets/images/lock.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.icon_user {
  background: url("../assets/images/user.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.icon_eye_open {
  background: url("../assets/images/passworld_open.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.icon_eye_close {
  background: url("../assets/images/passworld_close.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

:deep() .password_input {
  -webkit-text-security: disc;
}
.img_box {
  width: 537px;
  height: 560px;
  margin: 20px;
  background-color: #3764ff;
  border-radius: 6px;
}
.img_box img {
  width: 100%;
  height: auto;
  margin-top: 200px;
}
.login_from {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 80%;
  
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.login_title{
  font-size: 30px;
    color: #fff;
    box-sizing: border-box;
}
.login_from_box{
  background-color: #fff;
  width: 500px;
  height: 550px;
  margin: auto;
  border-radius: 20px;
  padding: 50px;
  box-sizing: border-box;
}
.login_box_title{
  text-align: center;
  /* padding-bottom: 50px; */
  font-size: 40px;
  height: 52px;
  line-height: 52px;
  font-family: 'Microsoft YaHei';
  font-weight: 600;
  color: #243042;
  margin-bottom: 70px;
}
.form_title {
  font-size: 32px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  color: #333333;
  letter-spacing: 2px;
  width: 486px;
  margin: 0 auto;
}
.form_title2 {
  margin: 0 auto;
  margin-top: 31px;
  font-size: 32px;
  letter-spacing: 2px;
  font-family: AlibabaPuHuiTi_2_75_SemiBold;
  color: #4384f4;
  margin-bottom: 51px;
  width: 486px;
}
/deep/.el-form-item__error {
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  color: #ff1e1e;
}
.from_center {
  width:100%;
  margin: 0 auto;
}
:deep(.red_bg .el-input__wrapper) {
  background: #fff1f1 !important;
}
:deep(.from_center .el-input__wrapper) {
  height: 47px;
  box-sizing: border-box;
  /* margin-bottom: 17px; */
  /* background: #f5f7fb; */
  border-radius: 10px;
  /* box-shadow: 0 0 0 0; */
  padding: 0 24px;
}

:deep(.from_center .el-input__inner) {
  font-size: 20px;
  font-family: AlibabaPuHuiTi_2_65_Medium;
  color: #333333;
  margin-left: 12px;
}

/deep/.el-form--inline .el-form-item {
  display: block !important;
  margin-right: 0 !important;
  margin-bottom: 35px;
}
/deep/ .el-input__password {
  font-size: 27px !important;
}
/deep/ .el-input__clear {
  font-size: 14px !important;
}

.submit_btn {
  width: 100%;
  height: 48px;
  line-height: 48px;
  border-radius: 4px;
  margin-top: 20px;
  font-size: 16px;
  font-family: AlibabaPuHuiTi_2_75_SemiBold;
  color: #ffffff;
}
.err_p {
  font-size: 12px;
  color: red;
}

/deep/.el-tooltip__trigger {
  position: absolute !important;
  right: -50px;
  width: 50px;
  height: 47px;
  line-height: 47px;
  top: 0px;
  font-size: 12px;
}
.item_btn {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>
